import type {
    Catalogs,
    FieldGroup,
    Provider,
    ProviderValues,
} from "@/pages/Providers/types";

export const providerGroups: FieldGroup[] = [
    {
        name: "general",
        fields: [
            { name: "name", required: true },
            { name: "trading_name" },
            { name: "tax_id", required: true },
            { name: "email", type: "email", required: true },
            { name: "phone", type: "tel" },
            { name: "fax", type: "tel" },
            { name: "website", type: "url" },
            {
                name: "provider_type_id",
                type: "select",
                catalog: "types",
                required: true,
            },
            {
                name: "speciality_ids",
                type: "multiple",
                catalog: "specialities",
            },
            { name: "notes", type: "textarea" },
        ],
    },
    {
        name: "address",
        fields: [
            { name: "address" },
            { name: "address_extra" },
            { name: "postal_code" },
            { name: "city" },
            { name: "province" },
            {
                name: "country_id",
                type: "select",
                catalog: "countries",
                required: true,
            },
        ],
    },
    {
        name: "legal",
        fields: [
            { name: "legal_name" },
            { name: "legal_tax_id" },
            { name: "legal_notary" },
            { name: "legal_protocol" },
            { name: "legal_power_date", type: "date" },
        ],
    },
    {
        name: "accounting",
        fields: [
            {
                name: "payment_method_id",
                type: "select",
                catalog: "payment_methods",
            },
            { name: "retention", type: "number" },
            { name: "guarantee", type: "number" },
            { name: "payment_blocked", type: "boolean" },
            {
                name: "validation_state_id",
                type: "select",
                catalog: "validation_states",
            },
        ],
    },
];

export const emptyProvider = (
    catalogs: Catalogs,
    provider?: Provider
): ProviderValues => {
    const values: ProviderValues = {
        name: "",
        trading_name: "",
        tax_id: "",
        email: "",
        phone: "",
        fax: "",
        website: "",
        provider_type_id: null,
        speciality_ids: [],
        notes: "",
        address: "",
        address_extra: "",
        postal_code: "",
        city: "",
        province: "",
        country_id: catalogs.default_country_id,
        legal_name: "",
        legal_tax_id: "",
        legal_notary: "",
        legal_protocol: "",
        legal_power_date: "",
        payment_method_id: null,
        validation_state_id: null,
        retention: null,
        guarantee: null,
        payment_blocked: false,
    };
    if (!provider) {
        return values;
    }

    return Object.fromEntries(
        Object.entries(values).map(([key, defaultValue]) => {
            const value = provider[key as keyof ProviderValues];
            switch (key) {
                case "payment_blocked":
                    return [key, Boolean(Number(value))];
                case "legal_power_date":
                    return [
                        key,
                        typeof value === "string" ? value.slice(0, 10) : "",
                    ];
                case "guarantee":
                case "retention":
                case "country_id":
                case "provider_type_id":
                case "validation_state_id":
                case "payment_method_id":
                    return [key, value == null ? null : Number(value)];
                default:
                    return [key, value ?? defaultValue];
            }
        })
    ) as unknown as ProviderValues;
};
